export const savePostAuthRedirect = (path: string) => {
  try {
    localStorage.setItem('redirectAfterLogin', path);
  } catch (err) {
    // Ignore storage access issues (e.g., Safari private mode)
    console.warn('Could not save redirect path', err);
  }
};

export const getPostAuthRedirect = (): string | null => {
  try {
    return localStorage.getItem('redirectAfterLogin');
  } catch {
    return null;
  }
};

export const clearPostAuthRedirect = () => {
  try {
    localStorage.removeItem('redirectAfterLogin');
  } catch {}
}; 